import { validFileExtensions } from "./const";

export const validateFileExtension = (filename) => {
  let value = false;
  let fileUploaded = filename.split(".");
  let fileExtn = fileUploaded[fileUploaded.length - 1].toUpperCase();
  let validFileExtn = validFileExtensions;
  let isValidFileExtn = validFileExtn.filter((extn) => extn === fileExtn);

  if (isValidFileExtn.length > 0) {
    value = true;
  }
  return value;
};

export const validateFileExtensionMimeType = (evt) => {
  let value = false;
  var ext = "";
  if (evt.target.readyState === FileReader.DONE) {
    const uint = new Uint8Array(evt.target.result);
    let bytes = [];
    uint.forEach((byte) => {
      bytes.push(byte.toString(16));
    });
    const hex = bytes.join("").toUpperCase();
    ext = getMimetype(hex);
    let validFileExtn = validFileExtensions;
    let isValidFileExtn = validFileExtn.filter((extn) => extn === ext);
    if (isValidFileExtn.length > 0) {
      value = true;
    }
    return value;
  }
};

function getMimetype(signature) {
  switch (signature) {
    case "89504E47":
      return "PNG";
    case "47494638":
      return "GIF";
    case "25504446":
      return "PDF";
    case "FFD8FFDB":
    case "FFD8FFE0":
      return "JPEG";
    case "FFD8FFE1":
      return "JPG";
    case "D0CF11E0":
      return "DOC";
    case "504B34":
      return "DOCX";
    default:
      return "Unknown";
  }
}
